import axios from "../../api/axiosInstance";

const ROOT = "/api/purchasing/user-item-access-rules";

export async function loadUserAccessPolicy(userId) {
  const query = userId == null ? "" : `?user_id=${encodeURIComponent(userId)}`;
  const [items, locations] = await Promise.allSettled([
    axios.get(ROOT + query),
    axios.get(ROOT + "/location-access" + query),
  ]);
  const itemRows = items.value?.data;
  const locationRows = locations.value?.data;
  if (!Array.isArray(itemRows) || !Array.isArray(locationRows)) {
    const messageKey = Array.isArray(locationRows) ? "itemLoadError" : Array.isArray(itemRows) ? "locationLoadError" : "loadError";
    throw Object.assign(new Error("Incomplete purchasing access configuration"), { messageKey });
  }
  return {
    rules: itemRows,
    locations: locationRows,
    migrationRequired: String(items.value.headers?.["x-purchasing-item-policy-version"]) === "1",
  };
}
